export interface Product {
  id: string;
  name: string;
  price: number;
  description: string;
  fullDescription: string;
  image: string;
  material: string;
  size: string;
  available: boolean;
  category: string;
}

export const products: Product[] = [
  {
    id: '1',
    name: 'Bague Dorée Serpent',
    price: 34.90,
    description: 'Bague fine dorée avec motif serpent enroulé, idéale pour un look bohème.',
    fullDescription: 'Cette magnifique bague dorée est ornée d\'un serpent finement sculpté qui s\'enroule autour du doigt. Fabriquée en acier inoxydable plaqué or 18 carats, elle est résistante aux allergies et conserve son éclat dans le temps. Un bijou parfait pour affirmer son style unique.',
    image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400&h=400&fit=crop',
    material: 'Acier inoxydable plaqué or 18K',
    size: 'Tailles 48 à 60',
    available: true,
    category: 'Bagues',
  },
  {
    id: '2',
    name: 'Collier Lune en Argent',
    price: 49.90,
    description: 'Collier délicat en argent sterling avec pendentif lune croissante.',
    fullDescription: 'Ce collier délicat en argent sterling 925 est orné d\'un pendentif lune croissante serti d\'un petit cristal. La chaîne fine et ajustable (40–45 cm) s\'adapte à toutes les morphologies. Parfait pour un port quotidien ou une occasion spéciale.',
    image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400&h=400&fit=crop',
    material: 'Argent sterling 925',
    size: 'Chaîne 40–45 cm',
    available: true,
    category: 'Colliers',
  },
  {
    id: '3',
    name: 'Bracelet Fin Minimaliste',
    price: 24.90,
    description: 'Bracelet fin et élégant en acier doré, style minimaliste.',
    fullDescription: 'Ce bracelet minimaliste en acier inoxydable doré est parfait pour les amateurs de bijoux discrets et raffinés. Sa fine chaîne dorée est ajustable et s\'adapte à tous les poignets. Il se porte seul ou superposé avec d\'autres bracelets pour un look tendance.',
    image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=400&h=400&fit=crop',
    material: 'Acier inoxydable doré',
    size: 'Ajustable 16–19 cm',
    available: true,
    category: 'Bracelets',
  },
  {
    id: '4',
    name: 'Boucles d\'Oreilles Créoles',
    price: 29.90,
    description: 'Créoles légères en or 18K, intemporelles et polyvalentes.',
    fullDescription: 'Ces créoles classiques en plaqué or 18 carats sont un indispensable de la garde-robe. D\'un diamètre de 30 mm, elles sont légères et confortables pour un port toute la journée. Leur fermeture sécurisée garantit une tenue parfaite.',
    image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=400&h=400&fit=crop',
    material: 'Plaqué or 18K',
    size: 'Diamètre 30mm',
    available: true,
    category: 'Boucles d\'oreilles',
  },
  {
    id: '5',
    name: 'Bague Manchette Gravée',
    price: 39.90,
    description: 'Bague manchette ouverte en argent avec gravure florale.',
    fullDescription: 'Cette bague manchette ouverte en argent sterling 925 est ornée d\'une délicate gravure florale faite à la main. Sa forme ouverte permet de l\'ajuster facilement à différentes tailles de doigts. Une pièce artisanale unique qui apporte une touche bohème à votre style.',
    image: 'https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=400&h=400&fit=crop',
    material: 'Argent sterling 925',
    size: 'Taille ajustable',
    available: true,
    category: 'Bagues',
  },
  {
    id: '6',
    name: 'Collier Perle Baroque',
    price: 59.90,
    description: 'Collier élégant avec pendentif perle baroque, style vintage.',
    fullDescription: 'Ce collier élégant est orné d\'une authentique perle baroque en eau douce montée sur une fine chaîne en argent sterling. La perle, de forme irrégulière naturelle, mesure environ 8–10 mm. Un bijou au charme vintage qui habille aussi bien une tenue décontractée qu\'une robe de soirée.',
    image: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=400&h=400&fit=crop',
    material: 'Perle d\'eau douce & argent 925',
    size: 'Chaîne 42 cm',
    available: false,
    category: 'Colliers',
  },
  {
    id: '7',
    name: 'Bracelet Jonc Doré',
    price: 44.90,
    description: 'Jonc rigide en or 14K, élégant et intemporel.',
    fullDescription: 'Ce jonc rigide en plaqué or 14 carats est un classique indémodable. Sa surface lisse et brillante reflète la lumière avec élégance. Légèrement ouvert, il s\'enfile facilement sur le poignet. Idéal à porter seul pour un effet épuré ou en superposition pour plus d\'impact.',
    image: 'https://images.unsplash.com/photo-1573408301185-9519f94a9c03?w=400&h=400&fit=crop',
    material: 'Plaqué or 14K',
    size: 'Diamètre intérieur 6 cm',
    available: true,
    category: 'Bracelets',
  },
  {
    id: '8',
    name: 'Boucles Pendantes Étoiles',
    price: 27.90,
    description: 'Boucles d\'oreilles pendantes avec étoiles et strass.',
    fullDescription: 'Ces boucles d\'oreilles pendantes légères mettent en valeur de petites étoiles serties de strass brillants. Longues de 4 cm, elles se balancent délicatement avec vos mouvements. Leur monture en acier hypoallergénique convient aux peaux sensibles.',
    image: 'https://images.unsplash.com/photo-1629224316810-9d8805b95e76?w=400&h=400&fit=crop',
    material: 'Acier hypoallergénique & strass',
    size: 'Longueur 4 cm',
    available: true,
    category: 'Boucles d\'oreilles',
  },
];
